// The scroll-in reveal on the home page's example cards (.home-scene).
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside sidebar_toggle.js, whose shape this is. Keyed on
// .home-scene, which only pages/welcome/*_scene.html.erb render, so it is
// inert everywhere else.
//
// One attribute, data-reveal, on the card: "armed" hides the staged rows
// (components/_home_scenes.scss), "in" lets them transition back, once. The
// card is VISIBLE UNTIL THIS MODULE ARMS IT, and it arms nothing when:
//
// - there is no IntersectionObserver — nothing would ever flip it to "in";
// - the reader asked for reduced motion — a card that fades in on scroll is
//   exactly the motion they asked not to have, so they get the still picture
//   the stylesheet draws by default;
// - the card is already on screen at load — arming it would blank something
//   the reader is looking at, then fade it back, which reads as a flicker.
//
// Each card is observed once and released the moment it enters, so the rows
// never re-hide on the way back up.

const SCENE = ".home-scene";
const THRESHOLD = 0.35;

function stillness() {
  return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function onScreen(el) {
  const rect = el.getBoundingClientRect();
  const viewport = window.innerHeight || document.documentElement.clientHeight;
  return rect.top < viewport && rect.bottom > 0;
}

function setup() {
  const scenes = Array.from(document.querySelectorAll(SCENE));
  if (scenes.length === 0) return;
  if (!("IntersectionObserver" in window) || stillness()) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.setAttribute("data-reveal", "in");
      observer.unobserve(entry.target);
    });
  }, { threshold: THRESHOLD });

  scenes.forEach((scene) => {
    if (onScreen(scene)) return;
    scene.setAttribute("data-reveal", "armed");
    observer.observe(scene);
  });
}

// The same guard every module in this pack carries — see mock_request_wizard.js.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setup);
} else {
  setup();
}
